import React from 'react'
import { Grid } from '@material-ui/core'
import AutomationTypeButtons from './AutomationTypeButtons'
import Scheduling from './Scheduling'
import { connect } from 'react-redux'

export default connect((state) => {
	const taskID = state.tasks.addOrEdit.taskID
	const task = state.tasks.tasksByID[taskID]
	const stats = task?.sms_stats || task?.email_stats
	const campaignStatus =
		state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
	const taskModalOpen = state.campaign.addOrEdit.taskModalOpen
	const disabled = Boolean(
		(taskModalOpen && taskID === 'new') ||
			stats ||
			campaignStatus === 'L' ||
			campaignStatus === 'C',
	)

	return {
		disabled,
	}
}, null)(({ disabled, delayCallToAction, scheduleCallToAction }) => (
	<>
		<Grid item xs={12}>
			<AutomationTypeButtons />
		</Grid>
		<Grid item xs={12}>
			<Scheduling
				delayCallToAction={delayCallToAction}
				scheduleCallToAction={scheduleCallToAction}
				typography={!disabled}
			/>
		</Grid>
	</>
))
